import { render, staticRenderFns } from "./MetricsView.vue?vue&type=template&id=1dda6d39&scoped=true&"
import script from "./MetricsView.vue?vue&type=script&lang=js&"
export * from "./MetricsView.vue?vue&type=script&lang=js&"
import style0 from "./MetricsView.vue?vue&type=style&index=0&id=1dda6d39&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dda6d39",
  null
  
)

export default component.exports